import request from "@/utils/request";

export function getRouterList(data) {
  return request.post('/menu/navigate', data);
}
